import type { TFunction } from 'i18next';
import type { Circuit } from '@/types/api';

function normalizeCircuitCode(value: string | null | undefined): string | null {
  const raw = value?.trim();
  if (!raw) return null;
  const match = raw.match(/C\d+[A-Z]?/i);
  return match ? match[0].toLowerCase() : null;
}

function circuitCodeFromId(circuitId: string): string | null {
  return normalizeCircuitCode(circuitId.replace(/^circuit_rebt_/i, ''));
}

function candidateKeyFromCircuitId(circuitId: string): string | null {
  const raw = circuitId.trim().replace(/^circuit_/i, '');
  return raw ? raw.toLowerCase() : null;
}

export function formatCircuitLabel(t: TFunction, circuit: Circuit): string {
  const candidateKey = candidateKeyFromCircuitId(circuit.circuit_id);
  if (candidateKey) {
    const translated = t(`electrical.circuit_ids.${candidateKey}`, { defaultValue: '' });
    if (translated) return translated;
  }

  const code = normalizeCircuitCode(circuit.rebt_code) ?? circuitCodeFromId(circuit.circuit_id);
  if (!code) return circuit.label;
  return t(`electrical.circuits.${code}`, { defaultValue: circuit.label });
}

export function formatLoadCategory(t: TFunction, category: string): string {
  return t(`electrical.categories.${category}`, { defaultValue: category });
}

export function formatRcdGroupLabel(t: TFunction, index: number): string {
  // Normalized uniform abbreviation for every RCD group: ID1, ID2, ID3, ...
  // (ID = Interruptor Diferencial). Numbered by display position, so it stays
  // contiguous regardless of backend (rcd_group_NN) vs editor-created (local_group_N) ids.
  const abbrev = t('electrical.groups.abbrev', { defaultValue: 'ID' });
  return `${abbrev}${index + 1}`;
}
